// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ab1bbbc4","239":"039bd343","732":"4ff02deb"}[chunkId] + ".chunk.js";
};